import React from "react"
import Relay from "react-relay"
import { Link, withRouter } from "react-router"
import Helmet from "react-helmet"
import classNames from "classnames"
import { injectIntl, FormattedMessage } from "react-intl"
import auth from "../../auth"
import { setToken } from "../../actions"
import { dispatch } from "../../Dispatcher"
import { userSetFragment } from "../modules/AddToSet"
import { trackEvent } from "../../analyticsAndSocial"
import { default as sharedMessages } from "../../messages"
import { default as profileMessages } from "../../messages/profile"
import { default as validationMessages } from "../../messages/validations"
import settingsMessages from "../../messages/settings"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { authenticAuthPasswordLengthValidator, authenticAuthPasswordStrengthValidator } from "../../utils/validations";

class Register extends React.Component {
  state = {
    email: "",
    password: "",
    username: "",
    loading: false,
    errors: {}
  }

  changeField = evt => {
    if (evt) evt.preventDefault()

    const { value, name } = evt.target
    this.setState({
      [name]: value,
      errors: {
        [name]: null
      }
    })
  }

  onSubmit = evt => {
    if (evt) evt.preventDefault()

    const {
      router,
      location: { query, hash },
      relay,
      intl
    } = this.props
    const { username: name, email, password } = this.state

    if (!name.length) {
      this.setState({ errors: { username: intl.formatMessage(validationMessages.signupBlankNameError) } })
      return
    }

    if (!email.length || !/^\S+@\S+$/.test(email)) {
      this.setState({ errors: { email: intl.formatMessage(validationMessages.invalidEmailError) } })
      return
    }

    if (!password.length) {
      this.setState({ errors: { password: intl.formatMessage(validationMessages.signupBlankPasswordError) } })
      return
    }

    if (!authenticAuthPasswordLengthValidator(password)) {
      this.setState({ errors: { password: intl.formatMessage(validationMessages.signupInvalidPasswordLength) } })
      return
    }

    if (!authenticAuthPasswordStrengthValidator(password)) {
      this.setState({ errors: { password: intl.formatMessage(validationMessages.signupPasswordNotStrong) } })
      return
    }

    this.setState({ loading: true })

    auth
      .register(
        { name, email, password },
        intl.formatMessage(settingsMessages.authenticAccountId)
      )
      .then(token => {
        this.setState({
          loading: false,
          errors: {}
        })
        dispatch(setToken(token))
        trackEvent("user", "signup")
      })
      .then(
        () =>
          new Promise((resolve, reject) => {
            // force clear relay cache of user sets
            relay.forceFetch(null, ({ done, error }) => {
              if (done) {
                resolve(done)
              } else if (error) {
                reject(error)
              }
            })
          })
      )
      .then(() => {
        const redirectUrl = query.redirectUrl ? `${query.redirectUrl}${hash}` : null
        const url = redirectUrl || null
        router.push(url || "/search")
      })
      .catch(err => {
        this.setState({
          errors:
            err.json && err.json.errors
              ? err.json.errors
              : {
                  error: intl.formatMessage(sharedMessages.somethingWentWrong)
                },
          loading: false
        })
      })
  }

  render() {
    const { email, username, password, errors, loading } = this.state
    const { intl } = this.props
    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const styleBodyType = accountSettings.settings.style.content || ""

    return (
      <main id="main" role="main" tabIndex={0} data-componant="Register">
        <Helmet title={`Register with ${accountSettings.name}`} />
        {styleBodyType === "default" && (
          <div className="row" id="item-info">
            <div className="small-12 columns">
              <h1 className="beta mbt">
                <FormattedMessage {...profileMessages.register} />
              </h1>
            </div>
          </div>
        )}

        <div className="row" id="item-info">
          {/*<div className="small-12 medium-7 columns auth__main-column">*/}
          {styleBodyType !== "default" ? (
            <div className="title" style={getStyles("p-offpage__title")}>
              Create Account
            </div>
          ) : null}
          <div className="small-12 columns auth__main-column">
            {getStyleTag("form-message")}
            <form
              onSubmit={this.onSubmit}
              className={classNames("form--can-load", {
                "state-form-loading": loading
              })}
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={this.changeField}
                placeholder={intl.formatMessage(sharedMessages.emailDefault)}
                required
              />
              {errors.email && (
                <span className="form-message state-error">{errors.email}</span>
              )}
              <input
                type="text"
                name="username"
                value={username}
                onChange={this.changeField}
                placeholder={intl.formatMessage(
                  profileMessages.displayNameDefault
                )}
                required
              />
              {errors.username && (
                <span className="form-message state-error">
                  {errors.username}
                </span>
              )}
              <input
                type="password"
                name="password"
                value={password}
                onChange={this.changeField}
                placeholder={intl.formatMessage(sharedMessages.passwordDefault)}
                required
              />
              {errors.password && (
                <span className="form-message state-error">
                  {errors.password}
                </span>
              )}

              {!!errors.error && (
                <div className="form-message state-error">{errors.error}</div>
              )}

              <div className="vertical-align-middle">
                <button
                  className={classNames("button man button--can-load", {
                    "state-loading": loading
                  })}
                  type="submit"
                  style={getStyles("p-offpage__form__button")}
                >
                  {styleBodyType === "default" ? (
                    <FormattedMessage {...profileMessages.createAnAccount} />
                  ) : (
                    "Register"
                  )}
                </button>
              </div>
            </form>
          </div>
          {/*<div className="small-12 medium-5 columns auth__social-column">
                  <button className="button">social</button>
                </div>*/}
        </div>
        {styleBodyType !== "default" && (
          <div
            className="bottom-links"
            style={getStyles("p-offpage__bottom__links")}
          >
            <span style={getStyles("p-offpage__bottom__links__text")}>
              Already have an account?
            </span>
            <Link to={{ pathname: "/login", query: this.props.location.query }} style={getStyles("p-offpage__bottom__link")}>
              Login
            </Link>
          </div>
        )}
      </main>
    )
  }
}

export default Relay.createContainer(withRouter(injectIntl(Register)), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        user_sets(first: 100) {
          edges {
            node {
              ${userSetFragment}
            }
          }
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/Register.js